(function () {
    'use strict';
    angular.module('Services').factory('ArchivesJobsTableService', ArchivesJobsTableService);

    ArchivesJobsTableService.$inject = [
        'FleetService',
        'ClientService',
        'TableLiteFactory',
        'toastr',
        '$q',
        'TypeStatusConsts',
        'Units',
        'ConfirmationModalFactory',
        '$rootScope',
        '$filter',
        '$uibModal',
        'ScanSummaryHelperService'
    ];

    function ArchivesJobsTableService(
        FleetService,
        ClientService,
        TableLiteFactory,
        toastr,
        $q,
        TypeStatusConsts,
        Units,
        ConfirmationModalFactory,
        $rootScope,
        $filter,
        $uibModal,
        ScanSummaryHelperService
    ) {
        return function (params, showAssignButton = false, loadUnassignedByDefault = false) {
            const {jobType, jobTypeValue, jobStatuses, jobStatusesValue} = TypeStatusConsts;
            const approveJobConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.approveJob.MESSAGE',
                code: 'messages.warning.approveJob.CODE',
            });

            let tableData = {
                tableName: 'JobsTable',
                optionAddOns: {
                    buttons: params.disableAdding ? null : [ {
                        class: 'btn-success',
                        label: 'Export',
                        onClick: () => {
                            const ids = [];
                            var columns = [];
                            tableData.headers.forEach(item => {
                                columns.push(item.viewName)
                            })
                            const selectedForExportJobs = tableData.data.filter(job => job.isSelected === true);
                            if (!selectedForExportJobs.length) {
                                toastr.warning('No jobs selected to export.');
                                return;
                            }
                            selectedForExportJobs.forEach(item => {
                                ids.push(item.id);
                            }
                            )
                            FleetService.Fleets.jobsExports(columns, ids,
                                res => {
                                    toastr.success('Successfuly exported!');
                                },
                                err => {
                                    toastr.error(err.message, err.code);
                                });

                        }
                    }],
                    selectFilters: [
                        {
                            label: 'Area',
                            ngModel: {label: 'N/A'},
                            width: '100px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function (search) {
                                this.dropDownIsFetching = true;
                                FleetService.Areas.getAll(data => {
                                    this.selectChoices = data.content.map(item => {
                                        return {
                                            label: item.areaId,
                                            areaName: item.areaId
                                        }
                                    });
                                    this.selectChoices.push({
                                        label: 'N/A'
                                    });

                                    this.dropDownIsFetching = false;
                                }, error => {
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                    areaId: search
                                });
                            },
                            onSelect: function (selected) {
                                const filter = {
                                    filter: {type: 'text', model: selected.areaName},
                                    filterName: "areaName",
                                }
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        },
                        {
                            label: 'Route',
                            ngModel: {label: 'N/A'},
                            width: '100px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function (search) {
                                this.dropDownIsFetching = true;
                                FleetService.Routes.getRoutes(data => {
                                    this.dropDownIsFetching = false;
                                    this.selectChoices = data.content.map(item => {
                                        return {
                                            label: item.name,
                                            routeName: item.name
                                        }
                                    });

                                    this.selectChoices.push({
                                        label: 'N/A'
                                    });
                                }, error => {
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                    name: search
                                });
                            },
                            onSelect: function (selected) {
                                const filter = {
                                    filter: {type: 'text', model: selected.routeName},
                                    filterName: "routeName",
                                }
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        }
                    ]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                }, {
                    label: 'DATE & TIME',
                    viewName: 'dateTime',
                    filterName: 'createdDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: '',
                        fromModel: '',
                        useArray: true,
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DRIVER',
                    width: '150px',
                    viewName: 'driverName',
                    filterName: 'driverId',
                    sortName: 'driver.firstName',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'driverName',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            FleetService.Drivers.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (driver) => {
                                    driver.driverName = driver.firstName + ' ' + driver.lastName;
                                    filterItems.push(driver);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 30, firstName: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.sortName);
                    }
                }, {
                    label: 'SORT CODE',
                    viewName: 'sortCode',
                    filterName: 'route.area.sortCode',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.sortName);
                    }
                }, {
                    label: 'JOB ID',
                    viewName: 'jobId',
                    filterName: 'jobId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Batch ID',
                    viewName: 'batchFormatted',
                    filterName: 'batchId',
                    filter: !angular.getObjVal(params, 'filters.batchId') ? {
                        type: 'text',
                        placeholder: 'Batch Id',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    } : {},
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'STATUS',
                    viewName: 'jobStatusFormatted',
                    filterName: 'jobStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        items: [{
                            value: jobStatusesValue.unassigned,
                            viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                        }, {
                            value: jobStatusesValue.forapproval,
                            viewName: jobStatuses[jobStatusesValue.forapproval.toLowerCase()]
                        }, {
                            value: jobStatusesValue.pending,
                            viewName: jobStatuses[jobStatusesValue.pending.toLowerCase()]
                        }, {
                            value: jobStatusesValue.accepted,
                            viewName: jobStatuses[jobStatusesValue.accepted.toLowerCase()]
                        }, {
                            value: jobStatusesValue.received,
                            viewName: jobStatuses[jobStatusesValue.received.toLowerCase()]
                        }, {
                            value: jobStatusesValue.inprogress,
                            viewName: jobStatuses[jobStatusesValue.inprogress.toLowerCase()]
                        }, {
                            value: jobStatusesValue.delivered,
                            viewName: jobStatuses[jobStatusesValue.delivered.toLowerCase()]
                        }, {
                            value: jobStatusesValue.failed,
                            viewName: jobStatuses[jobStatusesValue.failed.toLowerCase()]
                        }, {
                            value: jobStatusesValue.notyetstarted,
                            viewName: jobStatuses[jobStatusesValue.notyetstarted.toLowerCase()]
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BBA REFERENCE NO.',
                    viewName: 'bbaReferenceNumber',
                    filterName: 'bbaReferenceNumber',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'CONSIGNMENT',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'MANIFEST NUMBER',
                    viewName: 'manifestNumber',
                    filterName: 'manifestNumber',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'ORIGIN POSTCODE',
                    viewName: 'originPostcode',
                    filterName: 'sourceAddress.locationCode',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'ORIGIN SUBURB',
                    viewName: 'originSuburb',
                    filterName: 'sourceAddress.locationName',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DESTINATION POSTCODE',
                    viewName: 'destinationPostcode',
                    filterName: 'destinationAddress.locationCode',
                    width: '165px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DESTINATION SUBURB',
                    viewName: 'destinationSuburb',
                    filterName: 'destinationAddress.locationName',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PACKAGES',
                    viewName: 'packagesFormatted',
                    filterName: 'packages',
                    width: '100px'
                    /*filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }, {
                    label: 'PACKAGES SCANNED',
                    viewName: 'scanSummary'
                }, {
                    label: 'VEHICLE ID ',
                    width: '200px',
                    viewName: 'vehicleId',
                    filterName: 'driver.currentVehicle.vehicleId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'vehicleId',
                        filterBy: 'vehicleId',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            console.log('connect')
                            const defer = $q.defer();
                            let filterItems = this.items;
                            FleetService.Vehicles.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (vehicle) => {
                                    filterItems.push(vehicle);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 30, vehicleId: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    width: '200px',
                    viewName: 'companyName',
                    filterName: 'companyId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            ClientService.Company.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (vehicle) => {
                                    filterItems.push(vehicle);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 30, name: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Job Type',
                    viewName: 'jobType',
                    filterName: 'type',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        items: [{
                            value: jobTypeValue.p2p,
                            viewName: jobType[jobTypeValue.p2p]
                        }, {
                            value: jobTypeValue.delivery,
                            viewName: jobType[jobTypeValue.delivery]
                        }, {
                            value: jobTypeValue.pickUpOnly,
                            viewName: jobType[jobTypeValue.pickUpOnly]
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'AD HOC',
                    viewName: 'adhocStatus',
                    filterName: 'adhoc',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Yes', 'No'],
                        onSelect: function (header) {
                            const filter = {};

                            filter[header.filterName] = header.filter.model === 'Yes';

                            tableActions.sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    const filter = loadUnassignedByDefault ? {jobStatus: "UNASSIGNED"} : {}
                    tableActions.sendRequest(filter);
                }
            };

            // load unassigned by default 
            if (loadUnassignedByDefault) {
                tableData.headers.forEach(data => {
                    if (data.label == "STATUS") {
                        data.filter.model = {
                            value: jobStatusesValue.unassigned,
                            viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                        }
                    }
                });
            }

            // show assign button
            if (showAssignButton) {
                const assignButton = {
                    class: 'btn-primary',
                    label: 'ASSIGN SELECTED',
                    onClick: function () {
                        const selectedDrivers = tableData.data.filter(job => job.isSelected === true);
                        const vm = this;
                        if (selectedDrivers.length != 0) {
                            const modal = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/pages/jobs/add-ons/assignDriverModal.html',
                                controller: 'AssignDriverModalController',
                                controllerAs: 'vm',
                                windowClass: 'full-height-modal assign-job-modal',
                                size: 'sm',
                                appendTo: $('body'),
                                resolve: {
                                    selectedJobs: function () {
                                        return selectedDrivers;
                                    }
                                }
                            });

                            modal.result.then(function (data) {
                                refreshTable();
                            });
                        }
                    }
                }

                if (tableData.optionAddOns.buttons != null) {
                    tableData.optionAddOns.buttons.push(assignButton);
                }
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: angular.getObjVal(params, 'area.id') ? FleetService.Areas.getAreaJobs : FleetService.Jobs.getAll,
                    callbackFormat: angular.getObjVal(params, 'area.id') ? ['id', 'success', 'error', 'filter'] : ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: angular.getObjVal(params, 'area.id'),
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc',
                        'route.id': angular.getObjVal(params, 'route.id'),
                    }, params.filters || {})
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                let search = '';
                if (params.referrer === 'route') {
                    search = `?routeId=${params.route.id}`
                }
                if (params.referrer === 'area') {
                    search = `?areaId=${params.area.id}`
                }
                console.log(params)
                angular.forEach(data.content, function (item) {
                    const batch = item.batch || {};
                    const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
                    const totalPackagesCubicWeightFormatted = `(${batch.totalPackagesCubicWeight} cm<sup>3</sup>)`;
                    const batchFormatted = (item.batchId === 0 || angular.isUndefined(item.batchId)) ? 'N/A (AD HOC Job)' : null;
                    let totalPackageWeight = 0;
                    item.packages.forEach(pkg => {
                        totalPackageWeight += pkg.weight;
                    });

                    item.href = `/jobs/details/${item.id}${search}?archived=true`;
                    item.bbaReferenceNumber = item.bbaReferenceNumber || 'N/A';
                    item.originPostcode = angular.getObjVal(item, 'sourceAddress.location.code');
                    item.originSuburb = angular.getObjVal(item, 'sourceAddress.location.name');
                    item.destinationPostcode = angular.getObjVal(item, 'destinationAddress.location.code');
                    item.destinationSuburb = angular.getObjVal(item, 'destinationAddress.location.name');
                    item.manifestNumber = item.manifestNumber || 'N/A';
                    item.sortCode = angular.getObjVal(item, 'sortCode') || 'N/A';
                    item.packagesFormatted = {
                        type: 'multiLine',
                        list: item.packages ? item.packages.map(pack => {
                            const mUnit = Units.getMeasureUnit(pack.measureUnit);
                            const wUnit = Units.getWeightUnit(pack.weightUnit);
                            return pack.name || (`${pack.length} ${mUnit} x ${pack.length} ${mUnit} x ${pack.height} ${mUnit} / ${pack.weight} ${wUnit} (${pack.quantity} packs)`)
                        }) : []
                    };

                    item.dateTime = $filter('bbaDate')(item.createdDate, true);

                    item.driverName = `${angular.getObjVal(item, 'driver.firstName') || 'N/A'} ${angular.getObjVal(item, 'driver.lastName') || ''}`;
                    item.vehicleId = angular.getObjVal(item, 'driver.currentVehicle.vehicleId') || 'N/A';
                    item.jobType = jobType[item.type];
                    item.jobStatusFormatted = jobStatuses[(item.jobStatus || 'unassigned').toLowerCase()];
                    item.companyName = angular.getObjVal(item, 'company.name');

                    item.batchFormatted = {
                        type: 'multiLine',
                        list: item.adhoc ? [batchFormatted] : [angular.getObjVal(item, 'batch.batchId'), `(${batch.totalJobsNumber} Jobs)`, totalPackagesCubicWeightFormatted, `(${totalPackageWeight} ${weightUnit})`]
                    };

                    item.adhocStatus = {
                        type: 'status',
                        status: item.adhoc,
                        label: item.adhoc ? 'Yes' : 'No'
                    };
                    item.scanSummary = ScanSummaryHelperService.getScanSummary(item.scanSummary);
                    tableData.data.push(item);
                });

                reArrangeData();
            }

            function reArrangeData() {
                const batchIdWithGroups = [];
                let relatedJobGroups = [];
                tableData.data.forEach(data => {
                    if(data.batch) {
                        if (batchIdWithGroups.indexOf(data.batch.batchId) === -1) {
                            batchIdWithGroups.push(data.batch.batchId);
                            const relatedJobs = tableData.data.filter(job => angular.getObjVal(job, 'batch.batchId') === angular.getObjVal(data, 'batch.batchId'));

                            const jobs = relatedJobs.filter(job => job.jobId.includes('JOB'));
                            const jfm = relatedJobs.filter(job => job.jobId.includes('JFM'));
                            const jlh = relatedJobs.filter(job => job.jobId.includes('JLH'));
                            const jcd = relatedJobs.filter(job => job.jobId.includes('JCD'));
                            const jlm = relatedJobs.filter(job => job.jobId.includes('JLM'));

                            let reArrangeJobData = jobs;
                            reArrangeJobData = reArrangeJobData.concat(jfm);
                            reArrangeJobData = reArrangeJobData.concat(jlh);
                            reArrangeJobData = reArrangeJobData.concat(jcd);
                            reArrangeJobData = reArrangeJobData.concat(jlm);
                            relatedJobGroups = relatedJobGroups.concat(reArrangeJobData);
                        }
                    }
                    else {
                        relatedJobGroups.push(data);
                    }
                });
                tableData.data = relatedJobGroups;
            }

            function refreshTable() {
                tableActions.sendRequest({});
            }

            this.tableData = tableData;
            this.refreshTable = refreshTable;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/ArchivesJobsTableService.js